module.exports = __webpack_public_path__ + "img/id.7b7b2cb7.svg";